function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTargetFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.185 19.863a9.977 9.977 0 01-2.144 3.179 9.92 9.92 0 01-6.07 2.875V22.97h-2v2.947A9.933 9.933 0 018.9 23.042a9.996 9.996 0 01-2.143-3.18 9.911 9.911 0 01-.736-2.892h2.951v-2h-2.95A9.938 9.938 0 018.9 8.9a9.94 9.94 0 013.178-2.143 9.905 9.905 0 012.892-.737v2.95h2V6.02a9.921 9.921 0 012.892.737A9.93 9.93 0 0123.041 8.9a9.954 9.954 0 012.88 6.07h-2.95v2h2.95a9.88 9.88 0 01-.736 2.893zm5.785-4.893h-3.049a11.888 11.888 0 00-3.465-7.484 11.938 11.938 0 00-3.814-2.571 11.966 11.966 0 00-3.67-.891V.97h-2v3.054c-1.259.104-2.5.396-3.673.89a11.938 11.938 0 00-3.814 2.572A11.88 11.88 0 004.02 14.97H.971v2h3.05a11.893 11.893 0 003.464 7.486 11.966 11.966 0 003.814 2.57c1.173.497 2.405.79 3.672.896v3.048h2v-3.048a11.917 11.917 0 003.671-.895 11.966 11.966 0 003.814-2.571 11.9 11.9 0 003.465-7.486h3.05v-2z",
    fill: props.color
  }));
}

export default SvgIconTargetFilled;